import React, { forwardRef } from "react";
import "./FormField.css";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";

// component for form fields
// any props (other than label, icon, className and children) will be applied to the input element. this way you can specify the input type, event listeners, etc
// label prop will be used for the label html element
// icon prop (if there is one) should be the name of the icon without the mdi- prefix
// className prop will be added to the form-field container div
// any elements that would be displayed inside the field (like the password visibility toggle) should be inserted as a child element to FormField
// header prop is for elements to be displayed inline with the label, or otherwise above the input
// footer prop is for elements that need to be displayed below the input

const FormField = forwardRef((props, ref) => {
  const {
    pattern,
    id,
    className,
    label,
    header,
    icon,
    children,
    sideButton,
    footer,
    noMargin,
    type,
    defaultValue,
    nonHighlight,
    ...inputProps
  } = props;
  return (
    <div
      className={
        "form-field" +
        (className ? " " + className : "") +
        (noMargin ? " mb-1" : " mb-3")
      }
    >
      {label ? <label htmlFor={id}>{label}</label> : null}
      {header}
      <div className="form-input">
        {icon ? <i className={"form-icon mdi mdi-" + icon}></i> : ""}
        {children}
        {type === "textarea" ? (
          <textarea
            id={id}
            ref={ref}
            pattern={pattern}
            {...inputProps}
            // className={"form-control" + (icon ? " form-input-with-icon" : "")}
            children={null}
            defaultValue={defaultValue}
          />
        ) : (
          <input
            id={id}
            ref={ref}
            {...inputProps}
            type={type}
            className={
              (nonHighlight ? "form-control-non-highlight" : "form-control") +
              (icon ? " form-input-with-icon" : "")
            }
            children={null}
            pattern={pattern}
            defaultValue={defaultValue}
          />
        )}
        {sideButton ? (
          <ConfirmButton
            {...sideButton}
            className={
              "form-field-button px-3 ml-3 " +
              (sideButton.small ? "px-md-4" : "px-md-5")
            }
          >
            {sideButton.label}
          </ConfirmButton>
        ) : null}
      </div>
      {footer}
    </div>
  );
}
)

export default FormField;
